// extracted by mini-css-extract-plugin
var _1 = "AIGretaAskButton-moduleaiGretaAskButton__hPbTt AIButtonContainedLight-moduleaiButtonContainedLight__GOFKi";
export { _1 as "aiGretaAskButton" }
